import React from "react";
export function Footer() {
  return <footer className="w-full bg-navy-950 px-5 pb-32 pt-12 text-center" data-id="element-184" data-mp="19ivlq3plplne">
      <div className="mx-auto max-w-3xl" data-id="element-185" data-mp="206j4tmaouhfz">
        <p className="text-lg font-black text-white" data-id="element-186" data-mp="209nidaa1mpjb">SELF-LIGATING ORTHODONTICS BLUEPRINT™</p>
        <p className="text-sm font-semibold text-gold" data-id="element-187" data-mp="2f2qwt8sc8n5t">By Dr. Valeria Montes</p>
        <p className="mt-4 text-sm leading-relaxed text-white/70" data-id="element-188" data-mp="2a69xdifoumdf">
          A structured educational reference for orthodontists and dental professionals who want to understand self-ligating
          systems, biomechanics, and treatment-planning principles.
        </p>
        <p className="mt-6 text-xs leading-relaxed text-white/55" data-id="element-189" data-mp="1w67naidmgx8q">
          <strong className="text-white/75" data-id="element-190" data-mp="1rf9337pijf07">Professional Educational Disclaimer:</strong> This material is intended for qualified
          dental professionals and educational purposes only. It does not replace accredited orthodontic training, clinical
          supervision, patient-specific assessment, professional judgment, or applicable clinical guidelines. No particular
          bracket system is represented as universally superior.
        </p>
        <p className="mt-6 text-xs text-white/50" data-id="element-191" data-mp="1ii4dfomiswy6">
          © 2026 · Dr. Valeria Montes · SELF-LIGATING ORTHODONTICS BLUEPRINT™ · All Rights Reserved.
        </p>
      </div>
    </footer>;
}